import React from 'react'

import { Container } from './styles'

import Title from '../../Components/Title'

import { useHistory } from 'react-router-dom'
import Button from '../../Components/Button'

export default function AltaHospitalarPage(){
    const history = useHistory()
    return (
        <Container>
            <Title>Alta da Unidade</Title>

            <Button onClick={() => {
                history.push("/")
            }}>Encerrar</Button>
        </Container>
    )
}